import React, { useEffect, useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import { IconButton } from '@mui/material';
import s from './RecruitmentTeam.css';
import { useCarousel } from '../../../common/customHook/useCarousel';
import useGetRecruitmentTeam from '../../../common/apiCalls/homePage';

export default function RecruitmentTeam() {
  useStyles(s);
  const { data: homePageInfo = { recruitmentTeam: [] } } = useGetRecruitmentTeam();
  const TOTAL_SLIDES = homePageInfo?.recruitmentTeam.length;
  const [slidesInView, setSlidesInView] = useState(3);
  useEffect(() => {
    function handleResize() {
      const calculateSlidesInView = (pageWidth) => {
        if (pageWidth > 800) {
          return 3;
        }
        if (pageWidth > 500) {
          return 2;
        }
        return 1;
      };

      setSlidesInView(calculateSlidesInView(window.innerWidth));
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const carousel = useCarousel(slidesInView, TOTAL_SLIDES, { oneByOneSteps: true });
  const renderCard = (index) => (
    <div className={s.box}>
      <div>
        <img src={homePageInfo?.recruitmentTeam[index]?.image} alt={homePageInfo?.recruitmentTeam[index]?.name} />
      </div>
      <div>{homePageInfo?.recruitmentTeam[index]?.name}</div>
      <div>{homePageInfo?.recruitmentTeam[index]?.description}</div>
      <div>
        <a href={homePageInfo?.recruitmentTeam[index]?.linkedin}>LinkedIn</a>
      </div>
    </div>
  );
  return (
    <>
      {homePageInfo?.recruitmentTeam?.length > 0 && (
        <section>
          <h2>اعضای تیم جذب و استخدام</h2>
          <div>
            <div className={s.wrapper}>
              <IconButton onClick={carousel.prev}>
                <ArrowForwardIos />
              </IconButton>
              <div className={s.frame}>
                <div className={s.boxContainer} ref={carousel.ref}>
                  {homePageInfo?.recruitmentTeam.map((member, index) => renderCard(index))}
                </div>
              </div>
              <IconButton onClick={carousel.next}>
                <ArrowBackIos />
              </IconButton>
            </div>
          </div>
        </section>
      )}
    </>
  );
}
